export default __webpack_public_path__ + "static/media/SMM.3d32aecf.png";